import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { ReviewResponse, ReviewCategories, ReviewRegister, DataList } from '@shared/models';

import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class SurveyService {
  constructor(private apiService: ApiService) {}

  register(reviewData: ReviewRegister): Observable<ReviewResponse> {
    return this.apiService.post<ReviewResponse>(`user/surveys`, reviewData).pipe();
  }

  categories(): Observable<DataList<ReviewCategories>> {
    return this.apiService.get<DataList<ReviewCategories>>(`user/survey_categories`).pipe();
  }
}
